module.exports = __webpack_public_path__ + "static/media/7.3b64c5a5.jpg";